import type { SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

/**
 * Prepared element for text which have to perform in given way on click or tab focus
 */
export function ClickableTypography({
  perform,
  children,
  sx,
}: {
  perform: () => void;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}) {
  return (
    <Typography
      component="span"
      display="inline-block"
      fontWeight="medium"
      onClick={perform}
      onKeyDown={(event) => {
        if (event.code === 'Space' || event.code === 'Enter') {
          perform();
        }
      }}
      role="button"
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
        ...sx,
      }}
      tabIndex={0}
    >
      {children}
    </Typography>
  );
}
